import React, { useEffect, useState } from 'react'
import API from 'util/onboardApi'
import CardBox from 'components/CardBox'
import ContainerHeader from 'components/ContainerHeader'
import SnackBar from 'components/SnackBar'
import ActionsTable from "components/ActionsTable/TableList";
import { Alert } from "reactstrap";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide,Typography } from '@material-ui/core';
import { LinearProgress as LinearProgres } from "@material-ui/core";
import { Rating } from '@material-ui/lab';

import FormFilter from "../../../../../components/FormFilter"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
});
const getLabelText = (rating) => {
    switch (rating) {
      case 1:
        return 'Poor';
      case 2:
        return 'Fair';
      case 3:
        return 'Good';
      case 4:
        return 'Very Good';
      case 5:
        return 'Excellent';
      default:
        return 'Rate this';
    }
  };
const JobHistory = (props) => {

    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const [locations,setLocations] = useState([]);
    const [appliedJobs,setAppliedJobs] = useState(null);
    const [starValue,setStarValue] = useState(3);
    const [hoverValue, setHoverValue] = useState(-1);
    const [loading,setLoading] = useState(false);
    const [inputData,setInputData] = useState(null);
    const [dialog, setDialog] = useState({open:false, fullWidth:true, content:null, header:'', agreeBtnTxt:'', disAgreeBtnTxt:'', disableSubmit:false, type:'', callback:null});
    const requiredFields = {
        jobLocation: "Location is required",
        // job: "Job is required",
      };
    const onSubmit = async (inputs)=>{
        for (const [field, message] of Object.entries(requiredFields)) {
            if (!inputs[field]) {
                setSnackBar({
                open: true,
                message,
                type: "error",
                });
                return;
            }
        }
        if (!!inputs.startDate !== !!inputs.endDate) {
            setSnackBar({
              open: true,
              message: "Both Start Date and End Date must be provided together",
              type: "error",
            });
            return;
          }
        
        let data = {
            startDate : inputs.startDate ? new Date(inputs.startDate).getTime()/1000 : null,
            endDate: inputs.endDate ? new Date(inputs.endDate).getTime()/1000 : null,
            locationId: inputs.jobLocation?.location_id,
            jobId: inputs.job?.id
        }
        setInputData(inputs)
        const queryParams = new URLSearchParams(data).toString();
        setLoading(true);
        await API.get(`jobAppliedLists?${queryParams}`).then(res => {
            setAppliedJobs(res.data.data.appliedJobs);
            setLoading(false);
        }).catch(err =>{
            setLoading(false);
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            });
        })
    }

    const getLocationData = async ()=>{
        setLoading(true);
        await API.get('jobAppliedData').then(res=>{
            setLocations(res?.data?.data?.valet_jobs);
            setLoading(false);
        }).catch(err =>{
            setLoading(false);
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            });
        })
    }
    const jobStatusUpdate =  async (job,star)=>{
        setLoading(true);
        job = {...job, rating: star}
        await API.put('jobStatusUpdate',job).then(res=>{
            handleDialogClose();
            onSubmit(inputData);
            setLoading(false);
        }).catch(err =>{
            setLoading(false);
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            });
        })
    }
    const confirmJobStatusUpdate =  async (job)=>{
        setDialog({
            open:true,
            header: job?.started ? 'Start Job' : job?.accepted ? 'Approve Job' : 'Complete Job',
            content: job?.started ? 'Are you sure you want to start the Job?' : job?.accepted ? 'Are you sure you want to Approve the job?' : 'Are you sure you want to Complete the job? Please rate the valet',
            submitBtnLabel:'Confirm',
            disAgreeBtnTxt:'Cancel',
            userData: job,
            callback:jobStatusUpdate,
        })
    }
    const handleDialogClose = ()=>{
        setDialog({
            open:false,
            content:'',
            header:'',
            agreeBtnTxt:'',
            disAgreeBtnTxt:'',
            type:'',
            location:null,
            callback:null
        });
    }

    useEffect(()=>{
        getLocationData();
    },[])
    
    return (
        <>
            <ContainerHeader title={`Job Histories`} />

            <div className="row">
            <CardBox styleName="col-12">
            {
                locations && locations.length > 0?
                <FormFilter 
                    locations={locations}
                    onFormSubmit={onSubmit}
                    formSubmitText={'Get Details'}
                    flags = {{
                        "location": false,
                        "type": false,
                        "noMinDate": true,
                        "showDate": false,
                        "amount":false,
                        "reason":false,
                        "clients":false,
                        "selectDate":false,
                        "jobs": false,
                        "date": true,
                        "jobLocation": true,
                        "multiLocation": false,
                        "resetForm" : true
                    }}
                />:<></>
            }     
            </CardBox>
        </div>
        { loading &&  <div className='w-100'><LinearProgres color="primary" /></div> }

        {  
            appliedJobs && appliedJobs.body.length > 0 ?
                <div className="row">
                    <ActionsTable
						tableHeading={'Active Users'}
						table={appliedJobs}
						actions={true}
                        statusUpdate={confirmJobStatusUpdate}
					/>
                </div>
                : 
                appliedJobs && appliedJobs.body.length === 0 &&
                <Alert className="shadow-lg" color="primary">
                     No data for this period !</Alert>
        }
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
            <Dialog
				open={dialog.open}
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth='sm'
				onClose={handleDialogClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<LinearProgress style={{visibility:props.showProgress ? 'visible' : 'hidden'}} color="primary" />
				<DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
				<DialogContent>
					{dialog.content}
				</DialogContent>
                {
                    dialog?.userData?.completed &&
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                        <Rating
                            name="simple-controlled"
                            value={starValue}
                            size="large"
                            style={{ fontSize: 40 }}
                            onChangeActive={(event, newHover) => {
                                setHoverValue(newHover);
                            }}
                            onChange={(event, newValue) => {
                                setStarValue(newValue);
                            }}
                        />
                            {getLabelText(hoverValue !== -1 ? hoverValue : starValue)}
                    </div>

                }
				<DialogActions>
					{dialog.submitBtnLabel && 
						<Button variant="outlined"  color="primary" onClick={() => { dialog.callback(dialog.userData,starValue)}} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>}						
					<Button variant="outlined"  color="secondary" onClick={handleDialogClose}> Close</Button>
				</DialogActions>
			</Dialog>
        </>
    )

}

export default JobHistory;